import React from 'react';

import styles from './DetailTitle.module.css';

import { DetailItem } from '../../../types';

type Props = DetailItem;

export const DetailTitle = ({ detailTitle, detailData }: Props) => {
  return (
    <div className={styles.detail}>
      <h2 className={styles.detailTitle}>{detailTitle}</h2>
      <p className={styles.detailData}>{detailData}</p>
    </div>
  );
};
